import { DropDownFilter } from 'framework/list';
import { EmployeeContractTypeDropdown } from 'domain/shared/employee';
import { DefaultDropdownProps } from 'framework/form';

const ContractTypeFilter = (props: DefaultDropdownProps) => {
  return (
    <DropDownFilter {...props}>
      <EmployeeContractTypeDropdown {...props} />
    </DropDownFilter>
  );
};

export default ContractTypeFilter;
